import React from "react";
import PageTemplate from "../../componentes/PageTemplate";

export default function Projects() {
    return(
        <PageTemplate>
                <h3>Meus projetos</h3>
        </PageTemplate>
    )
}